var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchLine = function SvgSearchLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m11.619 10.77 2.57 2.57-.85.848-2.569-2.57A5.402 5.402 0 0 1 2 7.4c0-2.98 2.42-5.399 5.4-5.399a5.402 5.402 0 0 1 4.219 8.77Zm-1.204-.445A4.199 4.199 0 0 0 7.4 3.2a4.2 4.2 0 0 0-4.2 4.2 4.199 4.199 0 0 0 7.125 3.015z"
  })));
};
export default SvgSearchLine;